import { configureStore } from '@reduxjs/toolkit'
import tokenSaver from '../features/token/tokenSaver';
export default configureStore({
        reducer: {
            token: tokenSaver
        }
})